import * as React from 'react';
import { Input, Modal } from 'antd';
import './api-token-modals.scss';
import { simpleNotification } from '../../utils/index';
export var RenderApiTokenCreatedModal = function RenderApiTokenCreatedModal(props) {
  var newToken = props.newToken,
    _onCancel = props.onCancel;
  return Modal.confirm({
    icon: null,
    width: 620,
    className: 'api-token-created-modal',
    title: 'API Token Created',
    okText: 'Copy Token',
    cancelText: 'Close',
    onOk: function onOk() {
      navigator.clipboard.writeText(newToken).then(function () {
        simpleNotification('success', 'The API Token has been copied to your clipboard.');
      });
      return Promise.reject();
    },
    onCancel: function onCancel() {
      _onCancel();
    },
    content: /*#__PURE__*/React.createElement("div", {
      className: "api-token-created-modal-content"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, "Please save the token before leaving this window. Once this window is closed you will not be able to view the token again.")), /*#__PURE__*/React.createElement("div", {
      className: "api-token-field-value"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Input.Password, {
      size: "small",
      value: newToken
    }))))
  });
};